/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Beschaeftigungsverbot1Inputs */



/**

* @param {_Class_Beschaeftigungsverbot1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_beschaeftigungsverbot1 = /** @type {((inputs?: _Class_Beschaeftigungsverbot1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Beschaeftigungsverbot1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beschäftigungsverbot")
});
export { _class_beschaeftigungsverbot1 as "_class_Beschaeftigungsverbot" }